import { ThemeExposure } from '@api/api/theme-overview';
import { type AppTableFeatures } from '@design/components/table';
import { ColumnDef } from '@tanstack/react-table';
import { ThemeLogoIcon } from '@terminal/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';
import { TopRankIcon } from '@terminal/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';
import { TFunction } from 'i18next';

import styles from '../ThemeExposureTable.module.scss';

export const RANK_COLUMN_ID = 'rank';
const THEME_COLUMN_ID = 'theme';
const DESCRIPTION_COLUMN_ID = 'description';

export const getColumns = ({
  t,
}: {
  t: TFunction;
}): ColumnDef<AppTableFeatures, ThemeExposure>[] => [
  {
    id: RANK_COLUMN_ID,
    header: t('widget:assetOverview.knowledgeGraph.themeExposure.rank'),
    cell: props => {
      const { original } = props.row;
      return (
        <div className={styles.rankWrapper}>
          <TopRankIcon rank={original.relationship.rank} />
        </div>
      );
    },
  },
  {
    id: THEME_COLUMN_ID,
    header: t('assetOverview.knowledgeGraph.themeExposure.theme_industry'),
    cell: props => (
      <div className={styles.themeWrapper}>
        <div className={styles.styledLogoIconWrapper}>
          <ThemeLogoIcon
            name={props.row.original.theme.name}
            logo_url={props.row.original.theme.logo_url}
            type="industry"
            fallbackIcon={
              <div className={styles.logoWrapper}>
                {props.row.original.theme.name.charAt(0)}
              </div>
            }
          />
        </div>
        {props.row.original.theme.name}
      </div>
    ),
  },
  {
    id: DESCRIPTION_COLUMN_ID,
    header: t('widget:assetOverview.knowledgeGraph.themeExposure.description'),
    cell: props => {
      return (
        <div className={styles.descriptionWrapper}>
          {props.row.original.relationship.description}
        </div>
      );
    },
  },
];
